<div class="bg-white margin-left-14px margin-right-14px">
    <div class="border-soft-secondary border-left-0 border-right-0 border d-flex justify-content-between bg-white">
        <div class="align-items-center d-flex gap5px headerHeight textColorEncounter white-space-nowrap">
            <div class="d-flex headerHeight">
                <button class="align-items-center d-flex m-1 p-0 rounded-circle encounterBtn width30px height30px" (click)="toggleSideNav()">
                    <i [ngClass]="{'d-none':sideNav}" class="mdi mdi-chevron-left font-26"></i><i [ngClass]="{'d-none':!sideNav}" class="mdi d-none mdi-chevron-right font-26"></i>
                </button>
            </div>
            <div class="gap5px align-items-center" [ngClass]="timelineService.showBox?'d-none':'d-flex'">
                <div class="align-self-start avatar-sm">
                    <img *ngIf="appointment && appointment.patientThumbnailUrl" [src]="safe(appointment.patientThumbnailUrl)" class="rounded-circle avatar-sm" [alt]="appointment.patientName">
                    <span *ngIf="appointment && !appointment.patientThumbnailUrl" class="avatar-title rounded-circle bg-primary text-white" [textContent]="appointment.patientName | initials"></span>
                </div>
                <h4 class="font-16 white-space-nowrap"><a href="javascript:;" class="textColorEncounter font-17 text-capitalize cursor-default" *ngIf="appointment && appointment.patientName">{{appointment.patientName}}</a></h4>
            </div>
            <div class="d-flex gap5px h-100 p-1 align-items-center" *ngIf="appointment && appointment.providerName!==null">
                <div class="width30px">
                    <img class="w-100" src="assets/images/timelineSvg/encounter.svg" />
                </div>
                <h4 class="font-16 white-space-nowrap">Encounter by <a href="javascript:;" class="textColorEncounter font-17 text-capitalize cursor-default">{{appointment.providerName}}</a> on &nbsp;<span class="textColorEncounter fontAt1366px" [textContent]="appointment.appointmentDate|date:'dd/MM/yyyy'"></span><span class="fontAt1366px textColorEncounter">&nbsp;{{appointment.appointmentTimeString}}</span></h4>
            </div>
            <div class="d-flex heading-color1 font-18 font-weight-bold gap10px" title="title-mc">
                <div>
                    <span *ngIf="ancCards && ancCards.ga">GA</span>
                    <sub class="font-15 line-height-normal" style="margin-right: 3px;" *ngIf="ancCards && ancCards.ga" [textContent]="ancCards.ga"></sub>
                </div>
                <div class="no-padding" *ngIf="gpla">
                    <span *ngIf="gpla && gpla.gravida">G</span><sub class="font-15" style="margin-right: 3px;" [textContent]="gpla.gravida"></sub>
                    <span *ngIf="gpla && gpla.para">P</span><sub class="font-15" style="margin-right: 3px;" [textContent]="gpla.para"></sub>
                    <span *ngIf="gpla && gpla.living">L</span><sub class="font-15" style="margin-right: 3px;" [textContent]="gpla.living"></sub>
                    <span *ngIf="gpla && gpla.abortion">A</span><sub class="font-15" style="margin-right: 3px;" [textContent]="gpla.abortion"></sub>
                </div>
            </div>
            <div [ngClass]="timelineService.showBox?'d-none':'d-flex'" class="heading-color1 font-weight-bold" *ngIf="ancCards && ancCards.edd &&  roleId != 63">
                <span class="font-17">EDD:{{ancCards.edd}}</span>
            </div>
        </div>
        <div class="d-flex headerHeight">
            <button class="encounterBtn m-1 rounded-pill height30px" (click)="toggleIt()">
                <i style="margin-right: -6px" [ngClass]="timelineService.showBox?'d-none':'d-inline-block'" class="timelineIconsAign mdi mdi-chevron-left font-26"></i><img class="h-100" src="assets/images/timelineSvg/time-line.svg" /> <i style="margin-left: -6px " [ngClass]="timelineService.showBox?'d-inline-block':'d-none'" class="timelineIconsAign mdi mdi-chevron-right font-26"></i>
            </button>
        </div>
    </div>
    <div class="d-flex pt-1 pb-1">
        <div class="flex-grow-1 p-1">
            <div class="d-flex border encounterWedgets" *ngIf=" roleId != 63 && roleId != 82 " >
                <div class="align-items-center justify-content-center d-flex w-100-px w-75p">
                    <img class="w-75" src="../../../../assets/images/timelineSvg/riskfactor-c1.svg" />
                </div>
                <div class="flex-grow-1 m-1 pr-1 overflow-auto" *ngIf="antinantalRisk && antinantalRisk !== null &&  roleId != 63 && roleId != 82 ">
                    <div  class="font-weight-medium w-100">
                        <h5 class="white-space-nowrap heading-color2 mb-0 line-height-1" *ngIf="antinantalRisk && antinantalRisk.noRisk">Risk Factor</h5><span *ngIf="antinantalRisk && antinantalRisk.noRisk" class="text-black font-weight-semibold">No  Risk</span>
                        <div class="d-flex align-items-baseline" *ngIf="antinantalRisk &&( antinantalRisk.maternalmedical.length > 0|| antinantalRisk.uterineRiskFactor.length > 0 || antinantalRisk.pregnancyComplications.length > 0 || antinantalRisk.fetusComplications.length > 0 || antinantalRisk.characteristics.length > 0 || antinantalRisk.details.length > 0)">
                            <h5 class="white-space-nowrap w-130 heading-color2 m-0 mb-1 d-inline">Antinantal Risk :</h5>
                            <div class="w-100 mb-0 dashboard-break font-14 h-24px">
                                <ul style="column-gap: 35px;" class="row flex-wrap white-space-nowrap mb-0 line-height-1 text-black">
                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.maternalmedical" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.uterineRiskFactor" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.pregnancyComplications" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.fetusComplications" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.characteristics" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.details" [textContent]="item"></li>
                                </ul>
                            </div>
                        </div>


                        <div class="d-flex align-items-baseline font-weight-medium w-100" *ngIf="antinantalRisk &&( antinantalRisk.meternall.length > 0|| antinantalRisk.latePragnancy.length > 0 || antinantalRisk.currentPragnancy.length > 0 || antinantalRisk.funtalFetaus.length > 0 || antinantalRisk.maternalMedicalHistory.length > 0 || antinantalRisk.previousPregency.length > 0)">
                            <h5 class="white-space-nowrap w-130 heading-color2 m-0 mb-1 d-inline line-height-1">SGA Screening   : </h5>
                            <div class="w-100 mb-0 dashboard-break font-14 h-24px">
                                <ul style="column-gap: 35px;" class="row white-space-nowrap flex-wrap mb-0 line-height-1 text-black">
                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.meternall" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.previousPregency" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.currentPragnancy" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.maternalMedicalHistory" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.funtalFetaus" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.currentPragnancy" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.latePragnancy" [textContent]="item"></li>

                                </ul>
                            </div>
                        </div>

                        <div class="d-flex align-items-baseline font-weight-medium w-100" *ngIf="antinantalRisk && (antinantalRisk.highRisk.length > 0||antinantalRisk.intermediateRisk.length > 0|| antinantalRisk.lowRisk.length > 0  )">
                            <h5 class="white-space-nowrap w-130 heading-color3 m-0 mb-1 d-inline line-height-1">VTE Risk         : </h5>
                            <div class="w-100 mb-0 dashboard-break font-14 h-24px">
                                <ul style="column-gap: 35px;" class="row flex-wrap white-space-nowrap line-height-1 mb-0 text-black">
                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.highRisk" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.intermediateRisk" [textContent]="item"></li>

                                    <li class="alignItemFlex" *ngFor="let item of antinantalRisk.lowRisk" [textContent]="item"></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <h5 class="heading-color1 mb-0" *ngIf="!antinantalRisk">Risk Factor:</h5>
                    <div class="p-0 d-flex font-weight-medium w-100" *ngIf="roleId != 63 && roleId != 82">
                        <div *ngIf="!antinantalRisk">
                            <span class="line-height-20px heading-color1" style="font-size: medium;"><i class="rotatingExclamation mdi mdi-exclamation text-danger mr-1"></i>Section is not reviewed yet</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4 p-1 min-fit-width" *ngIf="!allergies && roleId != 63 && roleId != 82">
            <div class="d-flex border encounterWedgets">
                <div class="align-items-center justify-content-center d-flex w-100-px w-75p">
                    <img class="w-75" src="../../../../assets/images/timelineSvg/allergies-c2.svg" />
                </div>
                <div class="flex-grow-1 m-1">
                    <h5 class="heading-color1 mb-0" *ngIf="!allergies">Allergies Sections:</h5>
                    <div class="p-0 d-flex font-weight-medium w-100" *ngIf="roleId != 63 && roleId != 82">
                        <div *ngIf="!allergies">
                            <span class="line-height-20px heading-color1" style="font-size: medium;"><i class="rotatingExclamation mdi mdi-exclamation text-danger mr-1"></i>Section is not reviewed yet</span><br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4 p-1" *ngIf="specialFeature && specialFeature.specialFeature && roleId != 63 && roleId != 82">
            <div class="d-flex border encounterWedgets">
                <div class="align-items-center justify-content-center d-flex w-100-px w-75p">
                    <img class="w-75" src="../../../../assets/images/timelineSvg/special-features-c1.svg" />
                </div>
                <div class="flex-grow-1">
                    <h5 class="heading-color2 mb-0">Special Features:</h5>
                    <div class="break-all text-black" [textContent]="specialFeature.specialFeature"></div>
                    <div class="text-primary">see more....</div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--<div class="w-100 font-16">
    <div class="row d-flex">
        <div class="col-3" *ngIf="appointment && appointment.patientName!= null">
            <strong style="font-size:17px">Patient Name :</strong>&nbsp;
            <span [textContent]="appointment.patientName"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.umrNo!= null">
            &nbsp;
            <strong style="font-size:17px">UMR No  : </strong>&nbsp;
            <span [textContent]="appointment.umrNo"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.roomName!= null">
            <strong style="font-size:17px">Room Name :</strong>&nbsp;
            <span [textContent]="appointment.roomName"></span>
        </div>
        <div class="col-3" *ngIf="patient && patient.patient.admissionId != null">
            <strong style="font-size:17px">Admission  Id  :</strong>&nbsp;
            <span [textContent]="patient.patient.admissionId"></span>
        </div>
    </div>
    <div class="row d-flex font-weight-medium align-items-baseline mt-1">
        <div class="col-3" *ngIf="husbandName != null">
            <strong style="font-size:17px">Husband Name:</strong>&nbsp;
            <span [textContent]="husbandName"></span>
        </div>
        <div class="col-3" *ngIf="ancCardRecord && ancCardRecord.ancNo != null">
            &nbsp;
            <strong style="font-size:17px">ANC No:</strong>
            <span [textContent]="ancCardRecord.ancNo"></span>&nbsp;<span style="color:red;" *ngIf="ancCardClosed && ancCardClosed.ancCardClosed == 'Yes'">(C)</span>
        </div>
        <div class="col-3" *ngIf="visit != null">
            <strong style="font-size:17px">Visit No:</strong>&nbsp;
            <span [textContent]="visit"></span>
        </div>
        <div class="text-danger col-3" *ngIf="ancCards && ancCards.edd &&  roleId != 63 && roleId != 82">
            &nbsp;
            <strong style="font-size:17px">EDD:</strong>
            <span [textContent]="ancCards.edd"></span>
        </div>
        <div class="text-danger col-3" *ngIf="ancCards && ancCards.ultraSoundEdd &&  roleId != 63 && roleId != 82">
            &nbsp;
            <strong style="font-size:17px">Ultrasound EDD:</strong>
            <span [textContent]="ancCards.ultraSoundEdd | date: 'dd/MM/yyyy'"></span>
        </div>
    </div>
    <div id="patBarDet" class="w-100 col-12 align-items-end d-flex justify-content-between font-weight-bold" style="background-color: #dfdfe7" *ngIf="roleId != 63">
        <div class="row" title="title-mc" style="color:green; font-weight: bolder; font-size: 18px !important;">
            <span *ngIf="ancCards && ancCards.ga"> GA</span>
            <sub class="font-17" style="font-size:small" *ngIf="ancCards && ancCards.ga" [textContent]="ancCards.ga"></sub>&nbsp;&nbsp;&nbsp;
            <div class="col-6 no-padding" *ngIf="gpla">
                <span *ngIf="gpla && gpla.gravida">G</span><sub class="font-17" style="margin-right: 3px;" [textContent]="gpla.gravida"></sub>
                <span *ngIf="gpla && gpla.para">P</span><sub class="font-17" style="margin-right: 3px;" [textContent]="gpla.para"></sub>
                <span *ngIf="gpla && gpla.living">L</span><sub class="font-17" style="margin-right: 3px;" [textContent]="gpla.living"></sub>
                <span *ngIf="gpla && gpla.abortion">A</span><sub class="font-17" style="margin-right: 3px;" [textContent]="gpla.abortion"></sub>

            </div>
        </div>
        <div style="font-size: 18px !important; font-weight: bolder; color: #7c0000; margin-top: -6px" class="p-t-5 text-center col-xs-3 no-padding" *ngIf=" ancCards && ancCards.husbandBloodGroup!=null && ancCards.husbandRhType">
            <span *ngIf="ancCards && ancCards.husbandBloodGroup" class="pl-1" [textContent]="ancCards.husbandBloodGroup"></span><span *ngIf="ancCards && ancCards.husbandRhType" [textContent]="ancCards.husbandRhType"></span>
        </div>
    </div>
    <div *ngIf="specialFeature && specialFeature.specialFeature" class="d-flex font-weight-medium w-100">
        <strong class="white-space-nowrap" style="color: darkblue;">Special Features &nbsp;:</strong>&nbsp;
        <span class="break-all" [textContent]="specialFeature.specialFeature"></span>
    </div>
    <div *ngIf="antinantalRisk && antinantalRisk !== null &&  roleId != 63 && roleId != 82 " class="font-weight-medium w-100">
        <strong class="font-16">Risk Factor</strong><span *ngIf="antinantalRisk && antinantalRisk.noRisk">&nbsp;:</span><span *ngIf="antinantalRisk && antinantalRisk.noRisk" style="color:black">&nbsp; No  Risk</span>
        <div class="d-flex" *ngIf="antinantalRisk &&( antinantalRisk.maternalmedical.length > 0|| antinantalRisk.uterineRiskFactor.length > 0 || antinantalRisk.pregnancyComplications.length > 0 || antinantalRisk.fetusComplications.length > 0 || antinantalRisk.characteristics.length > 0 || antinantalRisk.details.length > 0)">
            <strong class="white-space-nowrap" style="color:#008fc5;">Antinantal Risk: </strong>
            <div class="w-100 mb-0 dashboard-break font-14 h-24px">
                <ul style="column-gap: 35px;" class="row flex-wrap mb-0">
                    <li *ngFor="let item of antinantalRisk.maternalmedical" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.uterineRiskFactor" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.pregnancyComplications" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.fetusComplications" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.characteristics" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.details" [textContent]="item"></li>
                </ul>
            </div>
        </div>


        <div *ngIf="antinantalRisk &&( antinantalRisk.meternall.length > 0|| antinantalRisk.latePragnancy.length > 0 || antinantalRisk.currentPragnancy.length > 0 || antinantalRisk.funtalFetaus.length > 0 || antinantalRisk.maternalMedicalHistory.length > 0 || antinantalRisk.previousPregency.length > 0)" class="d-flex font-weight-medium w-100">
            <strong class="white-space-nowrap" style="color: #7c0000;">SGA Screening: </strong>
            <div class="w-100 mb-0 dashboard-break font-14 h-24px">
                <ul style="column-gap: 35px;" class="row flex-wrap mb-0">
                    <li *ngFor="let item of antinantalRisk.meternall" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.previousPregency" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.currentPragnancy" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.maternalMedicalHistory" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.funtalFetaus" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.currentPragnancy" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.latePragnancy" [textContent]="item"></li>

                </ul>
            </div>
        </div>

        <div *ngIf="antinantalRisk && (antinantalRisk.highRisk.length > 0||antinantalRisk.intermediateRisk.length > 0|| antinantalRisk.lowRisk.length > 0  )" class="d-flex font-weight-medium w-100">
            <strong class="white-space-nowrap" style="color: seagreen;">VTE Risk: </strong>
            <div class="w-100 mb-0 dashboard-break font-14 h-24px">
                <ul style="column-gap: 35px;" class="row flex-wrap mb-0">
                    <li *ngFor="let item of antinantalRisk.highRisk" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.intermediateRisk" [textContent]="item"></li>

                    <li *ngFor="let item of antinantalRisk.lowRisk" [textContent]="item"></li>
                </ul>
            </div>
        </div>

    </div>

    <div id="mandatorySections" class="col-12 p-0 d-flex flex-wrap font-weight-medium w-100" *ngIf="roleId != 63 && roleId != 82">
        <div class="col-6 pl-0" *ngIf="!allergies">
            <span style="color:red;font-size: medium;"><i class="rotatingExclamation mdi mdi-exclamation text-danger mr-1"></i>Allergies section is not reviewed yet</span><br>
        </div>
        <div class="col-6" *ngIf="!antinantalRisk">
            <span style="color: red; font-size: medium;"><i class="rotatingExclamation mdi mdi-exclamation text-danger mr-1"></i>Risk Factors section is not reviewed yet</span>
        </div>
    </div>
</div>-->